import { useQueryClient } from 'react-query';

import { useDelete } from '../../utils/reactQuery';
import { ApiRoutesEnum } from '../../utils/routes';

export const useDeleteClientEmployee = () => {
  const queryClient = useQueryClient();
  const invalidateRegExp = /\/clients\/.*\/employees/g;
  return useDelete({
    url: ApiRoutesEnum.updateClientEmployee,
    onSuccess: () => {
      queryClient.invalidateQueries({
        predicate: (query) =>
          typeof query.queryKey[0] === 'string' && query.queryKey[0].match(invalidateRegExp) !== null,
      });
    },
  });
};
